// Fontloaders bundle - matches Gulp fontloaders task
// This bundle handles web font loading

import WebFont from 'webfontloader/webfontloader';

// Make WebFont available globally for inline scripts
window.WebFont = WebFont;

console.log('Fontloaders bundle loaded - WebFont available:', typeof WebFont);

// Signal that fontloaders bundle is ready
window.fontloadersReady = true;
window.dispatchEvent(new CustomEvent('fontloadersReady'));